export const finiteNumber = (value: unknown): number | null => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

export const isFiniteNumber = (value: unknown): value is number => typeof value === "number" && Number.isFinite(value);
